export default __webpack_public_path__ + "static/media/estate_guide_3.4e8be831.webp";